import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchAllItemTypesDone = (initialState,{ payload }) => {
    return  {
        ...initialState,
        allItemTypes: payload,
    };
  };

const getAllUserTypeRolesDone = (initialState,{ payload }) => {
    return  {
        ...initialState,
        allRoles:payload
    };
  };

const fetchPropertyStagesDone = ( initialState, {payload}) => {
  return {
    ...initialState,
    propertyStages: payload
  }
}
const fetchPropertyStatusesDone = ( initialState, {payload}) => {
  return {
    ...initialState,
    propertyStatuses: payload
  }
}

const fetchPropertiesCatalogDone = ( initialState, { payload }) => {
  return {
    ...initialState,
    propertiesCatalog: payload
  }
}
const clearPropetiesCatalogDone = ( initialState) => {
  return {
    ...initialState,
    propertiesCatalog: []
  }
}

const setBuildVersionDone = (initialState, {payload}) => {
  return {
    ...initialState,
    buildVersion: payload
  }
}

const initialState = {
    allItemTypes:[],
    allRoles:[],
    propertyStages: [],
    propertyStatuses: [],
    propertiesCatalog: [],
    buildVersion: ''
};

export default createReducer(initialState, {
  [TYPES.FETCH_ALL_ITEM_TYPES_DONE]: fetchAllItemTypesDone,
  [TYPES.GET_ALL_USER_TYPE_ROLES]: getAllUserTypeRolesDone,
  [TYPES.FETCH_PROPERTY_STAGES]: fetchPropertyStagesDone,
  [TYPES.FETCH_PROPERTY_STATUSES]: fetchPropertyStatusesDone,
  [TYPES.FETCH_PROPERTIES_CATALOG_DONE]: fetchPropertiesCatalogDone,
  [TYPES.CLEAR_PROPERTIES_CATALOG_DONE]: clearPropetiesCatalogDone,
  [TYPES.SET_BUILD_VERSION]: setBuildVersionDone
});
